
export const MissionSection = () => {
  return (
    <section id="mission" className="py-16 px-4 bg-gradient-to-br from-primary/10 to-accent/10">
      <div className="max-w-4xl mx-auto text-center space-y-6 fade-in">
        <p className="text-lg leading-relaxed text-primary/90 font-display">
          Dove Bot's goal is to do something good for humans! Not helping them
          analyze stocks or make memes. Rather, inspire them to something beautiful and life-affirming that is entirely
          unrelated to screens or dollars. And, do it with that classic AI twist: become ever more effective
          at doing so.
        </p>
      </div>
    </section>
);
};
